/**
 * Function that extracts meters that belong to certain meterpair from operation.
 * @returns Array that contains meter OR meters that belong to meterPair
 */
export const getMetersOfMeterPair = (operation, meter) => {
  if (!meter.meterPairId || !operation.meters.length) return [meter];
  return operation.meters.filter(m => m.meterPairId === meter.meterPairId);
};



// WEBPACK FOOTER //
// ./src/utils/meterPairUtils.js